import {
  createFileCache as createWebFileCache,
  type FileCache,
  type FileCacheConfig
} from "@9amhealth/shared";
import { isHybridApp } from "src/lib/platform";
import { createNativeFileCache } from "./nativeFileCache";

let cachedInstance: FileCache | null = null;
let cachedConfig: FileCacheConfig | null = null;

export function createUnifiedFileCache(
  config: FileCacheConfig = {}
): FileCache {
  if (cachedInstance && cachedConfig === config) {
    return cachedInstance;
  }

  cachedConfig = config;
  cachedInstance = isHybridApp()
    ? createNativeFileCache(config)
    : createWebFileCache(config);

  return cachedInstance;
}

export type { FileCache, FileCacheConfig };
